"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ParsedDesc_1 = require("./ParsedDesc");

var SetParser_1 = require("./parsers/SetParser");

var SetDesc =
/*#__PURE__*/
function (_ParsedDesc_1$ParsedD) {
  _inherits(SetDesc, _ParsedDesc_1$ParsedD);

  function SetDesc(members, desc, validators) {
    var _this;

    _classCallCheck(this, SetDesc);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SetDesc).call(this, new SetParser_1.SetParser(members), desc, validators));
    _this.members = members;
    return _this;
  }

  _createClass(SetDesc, [{
    key: "validate",
    value: function validate(input, level) {
      input = input === null || input === undefined ? [] : input;
      return _get(_getPrototypeOf(SetDesc.prototype), "validate", this).call(this, input, level);
    }
  }, {
    key: "withDescription",
    value: function withDescription(descr) {
      return new SetDesc(this.members, this.mergeDescs(descr), this.validators);
    }
  }, {
    key: "acceptVisitor",
    value: function acceptVisitor(visitor) {
      return visitor.visitSet(this);
    }
  }]);

  return SetDesc;
}(ParsedDesc_1.ParsedDesc);

exports.SetDesc = SetDesc;